import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { TOGGLE_DEACTIVATED_MUTATION } from './useToggleDeactivateProject.graphql';
import {
  IToggleDeactivateProjectMutationGraphQLResponse,
  IToggleDeactivateProjectMutationVariables,
  IHandleToggleDeactivateProjectParams,
  IUseToggleDeactivateProjectOptions,
  IUseToggleDeactivateProject,
} from './useToggleDeactivateProject.interfaces';

const useToggleDeactivateProject = (options?: IUseToggleDeactivateProjectOptions): IUseToggleDeactivateProject => {
  const { mutation, onCompleted, onError, token } = options ?? ({} as IUseToggleDeactivateProjectOptions);

  const [executeToggleDeactivateProject, { loading: isLoading }] = useLoggedGeladaMutation<
  IToggleDeactivateProjectMutationGraphQLResponse,
  IToggleDeactivateProjectMutationVariables
  >({
    mutation: mutation ?? TOGGLE_DEACTIVATED_MUTATION,
    options: {
      onCompleted: ({ project: { toggleDeactivate: isCompleted } }) => {
        if (!onCompleted) {
          return;
        }

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    token,
  });

  const handleToggleDeactivateProject = async ({ projectId, isDeactivated }: IHandleToggleDeactivateProjectParams) => {
    await executeToggleDeactivateProject({
      variables: {
        projectId,
        isDeactivated,
      },
    });
  };

  return {
    handleToggleDeactivateProject,
    isLoading,
  };
};

export { useToggleDeactivateProject };
